import Residencial from './residencial';

export default Residencial;